import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Switch, Form, Radio , Checkbox } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import icon_warning_desc from 'images/icon_warning_desc.svg';
import { useNavigate } from 'react-router-dom';
import icon_processing from 'images/icon_processing.svg';


const Columns = (props) => {
    let navigate = useNavigate();
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const [clickNext, setClickNext] = useState(false);
    const [headerMessage, setHeaderMessage] = useState('');
    const [rowMessage, setRowMessage] = useState('');
    const [IsSpinner, setIsSpinner] = useState(false);

    //// const [checkedDot, setCheckedDot] = useState(false)
    // const [disabledDot, setDisabledDot] = useState(false)
    //// const [checkedComma, setCheckedComma] = useState(false)
    // const [disabledComma, setDisabledComma] = useState(false)
    

    // useEffect(() => {
    //     if(props.checkedDot){
    //         setDisabledComma(true)
    //     } else {
    //         setDisabledComma(false)
    //     }
        
    //     if(props.checkedComma){
    //         setDisabledDot(true)
    //     } else {
    //         setDisabledDot(false)
    //     }

    // }, [props.checkedDot,props.checkedComma]);

    // const dotInputOnChange = (e) => {
    //     console.log('checked = ', e.target.checked);
    //     props.setCheckedDot(e.target.checked);
    //   };

    // const commaInputOnChange = (e) => {
    //     console.log('checked = ', e.target.checked);
    //     props.setCheckedComma(e.target.checked);
    // };



    const onChangeDotOrComma = (e) => {
        console.log('radio checked', e.target.value);
        props.setDotOrComma(e.target.value);
      };


    useEffect(() => {
        if (clickNext) {
            formCheck();
        } else {
            setClickNext(true);
        }
        // }, [props.headerInputValue, props.rowValue]);
    }, []);

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const handleClick = () => {
        if (formCheck()) {
            setIsSpinner(true);

            props.sendData().then((res) => {
                setIsSpinner(false);
            });
        }
    };

    const formCheck = () => {
        let headerMessage = '';
        let rowMessage = '';

        if (
            props.headerValue &&
            (props.headerInputValue <= 0 || props.headerInputValue == 0)
        ) {
            headerMessage = 'Header should be greater than 0.';
        } else if (
            props.headerValue &&
            props.headerInputValue > props.tableData.length
        ) {
            headerMessage = 'We do not heve that many rows.';
        }

        if (props.rowValue == 0 && props.headerValue) {
            rowMessage = 'Row number should be greater than header number.';
        } else if (props.rowValue == 0 && !props.headerValue) {
            rowMessage = 'Row number should be greater than 0.';
        } else if (
            props.headerValue &&
            props.rowValue <= props.headerInputValue
        ) {
            rowMessage = `Row number should be greater than header number.`;
        } else if (props.rowValue > props.tableData.length) {
            rowMessage = 'We do not heve that many rows.';
        }

        setHeaderMessage(headerMessage);
        setRowMessage(rowMessage);
        if (headerMessage !== '' || rowMessage !== '') {
            form.validateFields();
            return false;
        } else {
            return true;
        }
    };

    return (
        <Col className="select-data-right-side" span={12}>
            {/* <div className="icon-container">
                        <img
                            className="img-icon-container"
                            src={background_circle_green}
                        />
                        <img
                            className="icon-in-green-circle"
                            src={icon_in_green_circle}
                        />
                    </div> */}
            <div>
                <Row>
                    <Col>
                        <p className="title-header">Select Data</p>
                    </Col>
                </Row>

                {props.columnWarning ? (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'baseline',
                                fontSize: '16px',
                                fontFamily: 'Roboto Bold',
                                marginTop: '27px'
                            }}
                        >
                            <img
                                src={icon_warning_desc}
                                style={{ marginRight: '5px' }}
                            />
                            <div>
                                WARNING: Econometrica currently has a 30 column
                                limit.
                            </div>
                        </div>

                        <Col>
                            <div
                                className="p-desctiption"
                                style={{ paddingTop: '27px' }}
                            >
                                Specify the columns you want to include in the
                                box below.
                            </div>
                            <p className="p-desctiption2">
                                {'('}Use the following format: 1-25, 27, 37-40
                                {')'}.
                            </p>
                        </Col>

                        <Col className="d-flex-flex-column">
                            <label>Range of Columns</label>
                            <Input
                                onChange={props.handleRangeOfColumn}
                                placeholder="e.g. 1-25, 57, 37-40"
                                value={props.rangeOfColumn}
                            />
                        </Col>
                    </>
                ) : null}

                <Row className="d-flex-flex-column">
                    <Col>
                        <div className="p-desctiption">
                            Click on the toggle if you have headers to import.{' '}
                        </div>
                        <p className="p-desctiption2">
                            {'('}Headers typically contain column names. If you
                            don’t select this, all columns will be given the
                            default name: C1, C2, C3, etc{')'}.
                        </p>
                    </Col>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection:
                                windowSize.innerWidth > 1000 ? 'row' : 'column',
                            height: '76px'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection:
                                    windowSize.innerWidth > 1000
                                        ? 'column'
                                        : 'row'
                            }}
                        >
                            <label>Header (Optional)</label>
                            {/* <Input onChange={handleChangeHeaderInput} placeholder="e.g. 2" /> */}
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}
                            >
                                <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                    // checked={checked}
                                    style={{
                                        width: 50,
                                        marginTop:
                                            windowSize.innerWidth > 1000
                                                ? 5
                                                : 8,
                                        marginLeft:
                                            windowSize.innerWidth > 1000
                                                ? 0
                                                : 10
                                    }}
                                    onChange={props.handleHeaderChange}
                                />
                            </div>
                        </div>

                        {props.headerValue == 1 ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginLeft:
                                        windowSize.innerWidth > 1000
                                            ? '50px'
                                            : '0px'
                                }}
                            >
                                <label>Header row number:</label>
                                <Form
                                    form={form}
                                    initialValues={{
                                        remember: true
                                    }}
                                    onChange={props.handleChangeHeaderInput}
                                >
                                    <Form.Item
                                        label=""
                                        validateStatus={
                                            headerMessage == ''
                                                ? 'success'
                                                : 'error'
                                        }
                                        help={headerMessage}
                                    >
                                        <Input
                                            onChange={
                                                props.handleChangeHeaderInput
                                            }
                                            placeholder="e.g. 2"
                                            // value={props.headerInputValue}
                                        />
                                    </Form.Item>
                                </Form>
                            </div>
                        ) : null}
                    </div>

                    {props.csvFile ? (
                        <div className='decimal-separator-box'>
                            <div className='title'>
                                Be careful what you choose!
                                
                            </div>
                            <div className='desc'>
                                <p>In America, the decimal point is usually a small dot "."</p>
                                <p>In many other countries, the decimal point is a comma ","</p>
                            </div>
                            <div className='checkbox-container'>
                                {/* <div>
                                    <Checkbox checked={props.checkedDot} disabled={disabledDot} onChange={(e)=>{dotInputOnChange(e)}} >
                                        <label>Dot "."</label>
                                    </Checkbox>
                                </div>
                                <div>
                                    <Checkbox checked={props.checkedComma} disabled={disabledComma} onChange={(e)=>{commaInputOnChange(e)}}>
                                        <label>Comma ","</label>
                                    </Checkbox>
                                </div> */}
                                <Radio.Group onChange={onChangeDotOrComma} value={props.dotOrComma}>
                                    <Radio value={1}>Dot "."</Radio>
                                    <Radio value={2}>Comma ","</Radio>
                                </Radio.Group>
                            </div>
                        </div>
                    ) : null}
                    

                    <div
                        style={{
                            marginTop:
                                props.headerValue == 1 &&
                                windowSize.innerWidth < 1000
                                    ? '77px'
                                    : props.headerValue == 1 &&
                                      windowSize.innerWidth > 1000
                                    ? '47px'
                                    : props.headerValue == 0 &&
                                      windowSize.innerWidth > 1000
                                    ? '47px'
                                    : '0px'
                        }}
                    >
                        <div
                            className="p-desctiption"
                            style={{ paddingTop: 0 }}
                        >
                            Specify the first row containing data to be
                            analyzed.
                        </div>
                        <p className="p-desctiption2">
                            {'('}If the first row contains headers, it may lead
                            to errors{')'}.
                        </p>
                    </div>

                    <div className="d-flex-flex-column">
                        <label>
                            First Row {'('}Required{')'}
                        </label>

                        <Form
                            form={form}
                            initialValues={{
                                remember: true
                            }}
                            onChange={props.handleChangeRowInput}
                        >
                            <Form.Item
                                label=""
                                validateStatus={
                                    rowMessage ? 'error' : 'success'
                                }
                                help={rowMessage}
                            >
                                <Input
                                    onChange={props.handleChangeRowInput}
                                    placeholder="e.g. 2"
                                />
                            </Form.Item>
                        </Form>
                    </div>
                    <div style={{marginBottom: '30px'}}>
                        <label>Description:</label>
                        <TextArea onChange={(e)=>{props.setDescriptionValue(e.target.value)}} style={{border: '1px solid #d9d9d9!important'}}></TextArea>
                    </div>
                </Row>
            </div>

            <Row>
                <Col
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: 21
                    }}
                    span={24}
                >
                    {props.tableRender && props.tableData.length ? (
                        <Button
                            onClick={() => {
                                // props.sendData();
                                handleClick();
                            }}
                            className="blue-button"
                            style={{
                                width: 250,
                                marginTop: props.columnWarning ? 39 : 0
                            }}
                            type="primary"
                            block
                        >
                            {IsSpinner ? (
                                <img
                                    className="processing-spin"
                                    src={icon_processing}
                                />
                            ) : (
                                'Next'
                            )}
                            {/* Next */}
                        </Button>
                    ) : (
                        <Button
                            className="blue-button"
                            style={{
                                width: 250,
                                marginTop: props.columnWarning ? 39 : 0,
                                cursor: 'not-allowed'
                            }}
                            type="primary"
                            block
                        >
                            Next
                        </Button>
                    )}
                    <Button
                        onClick={() => navigate('/')}
                        style={{
                            width: 250,
                            marginTop: 15,
                            borderColor: '#578cba',
                            color: '#578cba'
                        }}
                        block
                    >
                        CANCEL
                    </Button>
                </Col>
            </Row>

            {/* <Row>
                        <Col span={24}>
                            <Button
                                onClick={sendData}
                                className="blue-button"
                                style={{ width: 250, marginTop: 150 }}
                                type="primary"
                                block
                            >
                                SAVE CHANGES
                            </Button>
                        </Col>
                    </Row> */}
        </Col>
    );
};

export default Columns;
